import { Button } from '#/components/Button/Button';
import type {
  ButtonSize,
  ButtonVariant,
} from '#/components/Button/Button.types';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { ListingType } from '#/types/ListingType';
import { showModal } from '#/zustand-stores/modalStore';

type Props = {
  className?: string;
  disabled?: boolean;
  listingId: string;
  listingType: ListingType;
  listingUrl: Record<string, string>;
  noIcon?: boolean;
  onClick?: () => void;
  size?: ButtonSize;
  messageOverride?: string;
  variant?: ButtonVariant;
  tabIndex?: number;
};

export function ShareListingButton({
  className,
  listingId,
  listingType,
  listingUrl,
  onClick,
  messageOverride,
  disabled,
  noIcon,
  size,
  variant,
  tabIndex,
}: Props) {
  const { i18n } = useI18n();

  return (
    <Button
      type="button"
      className={className}
      icon={noIcon ? undefined : { type: 'normalized', name: 'share' }}
      aria-label="Share"
      qaId="share-button"
      variant={variant ?? 'secondary'}
      disabled={disabled}
      tabIndex={tabIndex}
      size={size}
      onClick={(e) => {
        e.preventDefault();

        if (onClick) {
          onClick();
        }

        showModal('SHARE_LISTING', {
          listingId,
          listingType,
          listingUrl,
          messageOverride,
        });
      }}
    >
      {i18n('Share')}
    </Button>
  );
}
